module.exports = __webpack_public_path__ + "img/office.6b21b97d.png";